<script lang="ts">

    export let size = 28;
    export let color = '#fff';

</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size * (35.556 / 34.876)} viewBox="0 0 34.876 35.556">
    <path fill={color} d="M3115.526,589.517v31.972l-14.074-8.059-9.185,11.644V612.747H3080.65Zm-1.007,1.51-19.911,21.1v6.7Z" transform="translate(-3080.65 -589.517)"/>
</svg>
  